import { createRoute, redirect } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { siteRoute } from '../layouts';
import { discountsLeaves } from './discounts';

const pages = () => import('./pages');
const listsComp = lazyPage(pages, 'PriceListsHost');
const createComp = lazyPage(pages, 'PriceListCreateHost');
const editComp = lazyPage(pages, 'PriceListEditHost');
const editorComp = lazyPage(pages, 'PriceEditorHost');
const variantComp = lazyPage(pages, 'VariantPricingHost');

/** SiteId/siteEnv for an absolute redirect out of a site child, parsed from the current path. */
function sitePairFrom(location: { pathname: string }) {
  const [, siteId, siteEnv] = location.pathname.split('/');
  return { siteId: siteId ?? '', siteEnv: siteEnv ?? '' };
}

// /pricing redirects to the price lists page.
const pricingIndexRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing',
  beforeLoad({ location }) {
    const { siteId, siteEnv } = sitePairFrom(location);
    throw redirect({ to: '/$siteId/$siteEnv/pricing/lists', params: { siteId, siteEnv } });
  },
});

const priceListsRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/lists',
  component: listsComp,
  staticData: { title: 'Price Lists' },
});

const priceListCreateRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/lists/create',
  component: createComp,
  staticData: { title: 'Price List Create' },
});

const priceListEditRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/lists/edit/$slug',
  component: editComp,
  staticData: { title: 'Price List Edit' },
});

const priceEditorRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/editor',
  component: editorComp,
  staticData: { title: 'Price Editor' },
});

const priceEditorVariantRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/editor/$variantId',
  component: variantComp,
  staticData: { title: 'Price Editor' },
});

/** Pricing family leaves to attach under the site-env layout. */
export const pricingLeaves = [
  pricingIndexRoute,
  priceListsRoute,
  priceListCreateRoute,
  priceListEditRoute,
  priceEditorRoute,
  priceEditorVariantRoute,
  ...discountsLeaves,
];
